// Generated by Melange

import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

const ViewGridAdd = {};

const XCircle = {};

const TrashSolid = {};

const Search = {};

const ExclamationCircle = {};

const CheckCircle = {};

const CogSolid = {};

const MenuAlt1 = {};

const ChevronLeft = {};

const ChevronRight = {};

const Clock = {};

const ChartPie = {};

const UserGroup = {};

const Key = {};

const Pencil = {};

const Eye = {};

const HeroIcons = {
  ViewGridAdd: ViewGridAdd,
  XCircle: XCircle,
  TrashSolid: TrashSolid,
  Search: Search,
  ExclamationCircle: ExclamationCircle,
  CheckCircle: CheckCircle,
  CogSolid: CogSolid,
  MenuAlt1: MenuAlt1,
  ChevronLeft: ChevronLeft,
  ChevronRight: ChevronRight,
  Clock: Clock,
  ChartPie: ChartPie,
  UserGroup: UserGroup,
  Key: Key,
  Pencil: Pencil,
  Eye: Eye
};

const IconDocuments = {};

const IconHome = {};

const IconCatalog = {};

const IconSklad = {};

const IconKassa = {};

const IconTaxes = {};

const IconSettings = {};

const Sidebar = {
  IconDocuments: IconDocuments,
  IconHome: IconHome,
  IconCatalog: IconCatalog,
  IconSklad: IconSklad,
  IconKassa: IconKassa,
  IconTaxes: IconTaxes,
  IconSettings: IconSettings
};

const IconPlus = {};

const IconDropdown = {};

const IconSelectArrows = {};

const IconCheck = {};

function make(param) {
  return function (param) {
    return function (circleColorOpt) {
      const circleColor = circleColorOpt !== undefined ? circleColorOpt : "#818C96";
      return JsxRuntime.jsxs("svg", {
                  children: [
                    JsxRuntime.jsx("circle", {
                          cx: "20",
                          cy: "20",
                          fill: circleColor,
                          r: "20"
                        }),
                    JsxRuntime.jsx("path", {
                          clipRule: "evenodd",
                          d: "M20.5999 12.9999C20.5999 12.6685 20.3313 12.3999 19.9999 12.3999C19.6685 12.3999 19.3999 12.6685 19.3999 12.9999V19.3999H13.4999C13.1685 19.3999 12.8999 19.6685 12.8999 19.9999C12.8999 20.3313 13.1685 20.5999 13.4999 20.5999H19.3999V26.9999C19.3999 27.3313 19.6685 27.5999 19.9999 27.5999C20.3313 27.5999 20.5999 27.3313 20.5999 26.9999V20.5999H26.4999C26.8313 20.5999 27.0999 20.3313 27.0999 19.9999C27.0999 19.6685 26.8313 19.3999 26.4999 19.3999H20.5999V12.9999Z",
                          fill: "white",
                          fillRule: "evenodd"
                        })
                  ],
                  height: "40",
                  width: "40",
                  fill: "none",
                  viewBox: "0 0 40 40",
                  xmlns: "http://www.w3.org/2000/svg"
                });
    };
  };
}

function Icons$IconAddInCircle(Props) {
  return Curry._1(make(Props.alt)(Props.className), Props.circleColor);
}

const IconAddInCircle = {
  make: Icons$IconAddInCircle
};

const DropdownArrow = {};

const IconSelectArrowsLinks = {};

const IconSelectArrowsWhite = {};

const Search$1 = {};

const IconNotification = {};

const IconDate = {};

const IconReturn = {};

const IconEdit = {};

const IconDone = {};

const IconCurvedArrowRight = {};

const IconCurvedArrowDown = {};

const Info = {};

const IconPieChart = {};

function make$1(param) {
  return function (param) {
    return JsxRuntime.jsxs("svg", {
                children: [
                  JsxRuntime.jsxs("g", {
                        children: [
                          JsxRuntime.jsx("path", {
                                clipRule: "evenodd",
                                d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                                fill: "#818C96",
                                fillRule: "evenodd"
                              }),
                          JsxRuntime.jsx("path", {
                                clipRule: "evenodd",
                                d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                                fill: "#747F88",
                                fillRule: "evenodd"
                              })
                        ],
                        clipPath: "url(#clip0)"
                      }),
                  JsxRuntime.jsx("defs", {
                        children: JsxRuntime.jsx("clipPath", {
                              children: JsxRuntime.jsx("path", {
                                    d: "M0 0H20V20H0V0Z",
                                    fill: "white"
                                  }),
                              id: "clip0"
                            })
                      })
                ],
                height: "20",
                width: "20",
                fill: "none",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              });
  };
}

function Icons$IconCard(Props) {
  return make$1(Props.alt)(Props.className);
}

const IconCard = {
  make: Icons$IconCard
};

const IconClose = {};

const IconArrowUp = {};

const IconLink = {};

const IconPrint = {};

const IconSettingsMini = {};

const IconLogo = {};

const IconMenu = {};

const IconCloseArrows = {};

const IconCloseCircle = {};

const IconPlus24 = {};

const IconArrowBack = {};

const IconArchive = {};

const IconMoveToCategory = {};

const IconMore = {};

const Employee = {};

const Table = {};

const Address = {};

const Chashier = {};

function make$2(size) {
  return function (children) {
    return JsxRuntime.jsx("div", {
                children: children,
                className: size
              });
  };
}

function Icons$ResizableSVG(Props) {
  return make$2(Props.size)(Props.children);
}

const ResizableSVG = {
  make: Icons$ResizableSVG
};

const User = {};

const Phone = {};

const Mail = {};

const Note = {};

const Visible = {};

const IconMoreWhite = {};

const Attach = {};

const Category = {};

const $$Image = {};

const EyeOpened = {};

const EyeClosed = {};

const IconDelete = {};

const IconCopy = {};

const Xls = {};

const CardBlack = {};

function make$3(param) {
  return function (param) {
    return JsxRuntime.jsxs("svg", {
                children: [
                  JsxRuntime.jsxs("g", {
                        children: [
                          JsxRuntime.jsx("path", {
                                clipRule: "evenodd",
                                d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                                fill: "#232837",
                                fillRule: "evenodd"
                              }),
                          JsxRuntime.jsx("path", {
                                clipRule: "evenodd",
                                d: "M2.0213 10.1802C1.60709 9.46276 1.8529 8.54538 2.57034 8.13116L12.0966 2.63116C12.8141 2.21695 13.7314 2.46276 14.1457 3.1802L15.1873 4.98442L3.06297 11.9844L2.0213 10.1802ZM2.44658 12.9168C2.4467 12.917 2.44682 12.9172 2.44694 12.9174C2.44706 12.9176 2.44718 12.9179 2.4473 12.9181L4.98861 17.3197C5.67896 18.5155 7.20794 18.9251 8.40367 18.2348L17.93 12.7348C19.1257 12.0444 19.5354 10.5155 18.845 9.31973L16.6106 5.44968L16.3033 4.91743L15.0117 2.6802C14.3213 1.48447 12.7923 1.07478 11.5966 1.76514L2.07034 7.26514C0.874605 7.95549 0.464919 9.48447 1.15527 10.6802L2.44658 12.9168ZM15.6873 5.85044L15.7446 5.94968L17.979 9.81973C18.3932 10.5372 18.1474 11.4546 17.43 11.8688L7.90367 17.3688C7.18623 17.783 6.26885 17.5372 5.85463 16.8197L3.56297 12.8504L15.6873 5.85044Z",
                                fill: "#232837",
                                fillRule: "evenodd"
                              })
                        ],
                        clipPath: "url(#clip0)"
                      }),
                  JsxRuntime.jsx("defs", {
                        children: JsxRuntime.jsx("clipPath", {
                              children: JsxRuntime.jsx("path", {
                                    d: "M0 0H20V20H0V0Z",
                                    fill: "white"
                                  }),
                              id: "clip0"
                            })
                      })
                ],
                height: "20",
                width: "20",
                fill: "none",
                viewBox: "0 0 20 20",
                xmlns: "http://www.w3.org/2000/svg"
              });
  };
}

function Icons$IconCardBlack(Props) {
  return make$3(Props.alt)(Props.className);
}

const IconCardBlack = {
  make: Icons$IconCardBlack
};

const IconCash = {};

const Kyrgyzstan = {};

const Uzbekistan = {};

const KazakhstanRound = {};

const XReport = {};

const GuardCircled = {};

const CheckLightBlue = {};

const Cashier = {};

const Step = {};

const CheckGreen = {};

const DropdownArrowBlue = {};

const Tickets = {};

const Soon = {};

const Nommi = {};

const Visa = {};

const ForwardPink = {};

const Papers = {};

const Integration = {};

const Mastercard = {};

const Mir = {};

const NumberOneCheckLarge = {};

const NumberTwoCheckLarge = {};

const NumberThreeCheckLarge = {};

const NumberFourCheckLarge = {};

const TicketsBlue = {};

const Question = {};

const Avatar = {};

const Play = {};

const Minus = {};

const UnionPay = {};

const CheckBlue = {};

const Jcb = {};

const QuestionBlue = {};

const At = {};

const PlusBlack = {};

const Amex = {};

const NumberFiveCheckLarge = {};

const AtBlue = {};

const DocsBlack = {};

const NumberSixCheckLarge = {};

const Russia = {};

const $$Location = {};

const Report = {};

const Language = {};

const Forward = {};

const Target = {};

const Guard = {};

const Abacus = {};

const NumberOneCheck = {};

const IconLogoWhite = {};

const Glovo = {};

const ForwardGray = {};

const DavaiShodim = {};

const Stonk = {};

const Checks = {};

const Check2 = {};

const GlovoCircled = {};

const GlovoGray = {};

const UserCircled = {};

const PlusBlue = {};

const DocsBlack24 = {};

const IntegrationAvatar = {};

const IconLogoBlack = {};

const IconFormError = {};

const IconDocs = {};

const NumberTwoCheck = {};

const MenuMobileActive = {};

const ForwardBlue = {};

const Invoice = {};

const DocFlow = {};

const HalykCircled = {};

const TicketsCircled = {};

const Cart = {};

const Salary = {};

const InDriverGray = {};

const ESF = {};

const IconClock = {};

const IconCheck24 = {};

const NumberThreeCheck = {};

const MenuMobileWhite = {};

const ForwardLightBlue = {};

const Card24 = {};

const Tis = {};

const IconDownload = {};

const IconRefresh = {};

const QuestionGreen = {};

const API = {};

const NumberFourCheck = {};

const MenuMobile = {};

const VisaLight = {};

const Kassa = {};

const ProductAccount = {};

const PersonalSupport = {};

const LargeBusiness = {};

const NumberFiveCheck = {};

const Chat = {};

const Restaurant = {};

const UserBlack = {};

const Retail = {};

const NumberSixCheck = {};

const World = {};

const Wholesale = {};

const Pricing = {};

const OnlineStore = {};

const ContractCircled = {};

const DocsCircled = {};

export {
  HeroIcons ,
  Sidebar ,
  IconPlus ,
  IconDropdown ,
  IconSelectArrows ,
  IconCheck ,
  IconAddInCircle ,
  DropdownArrow ,
  IconSelectArrowsLinks ,
  IconSelectArrowsWhite ,
  Search$1 as Search,
  IconNotification ,
  IconDate ,
  IconReturn ,
  IconEdit ,
  IconDone ,
  IconCurvedArrowRight ,
  IconCurvedArrowDown ,
  Info ,
  IconPieChart ,
  IconCard ,
  IconClose ,
  IconArrowUp ,
  IconLink ,
  IconPrint ,
  IconSettingsMini ,
  IconLogo ,
  IconMenu ,
  IconCloseArrows ,
  IconCloseCircle ,
  IconPlus24 ,
  IconArrowBack ,
  IconArchive ,
  IconMoveToCategory ,
  IconMore ,
  Employee ,
  Table ,
  Address ,
  Chashier ,
  ResizableSVG ,
  User ,
  Phone ,
  Mail ,
  Note ,
  Visible ,
  IconMoreWhite ,
  Attach ,
  Category ,
  $$Image ,
  EyeOpened ,
  EyeClosed ,
  IconDelete ,
  IconCopy ,
  Xls ,
  CardBlack ,
  IconCardBlack ,
  IconCash ,
  Kyrgyzstan ,
  Uzbekistan ,
  KazakhstanRound ,
  XReport ,
  GuardCircled ,
  CheckLightBlue ,
  Cashier ,
  Step ,
  CheckGreen ,
  DropdownArrowBlue ,
  Tickets ,
  Soon ,
  Nommi ,
  Visa ,
  ForwardPink ,
  Papers ,
  Integration ,
  Mastercard ,
  Mir ,
  NumberOneCheckLarge ,
  NumberTwoCheckLarge ,
  NumberThreeCheckLarge ,
  NumberFourCheckLarge ,
  TicketsBlue ,
  Question ,
  Avatar ,
  Play ,
  Minus ,
  UnionPay ,
  CheckBlue ,
  Jcb ,
  QuestionBlue ,
  At ,
  PlusBlack ,
  Amex ,
  NumberFiveCheckLarge ,
  AtBlue ,
  DocsBlack ,
  NumberSixCheckLarge ,
  Russia ,
  $$Location ,
  Report ,
  Language ,
  Forward ,
  Target ,
  Guard ,
  Abacus ,
  NumberOneCheck ,
  IconLogoWhite ,
  Glovo ,
  ForwardGray ,
  DavaiShodim ,
  Stonk ,
  Checks ,
  Check2 ,
  GlovoCircled ,
  GlovoGray ,
  UserCircled ,
  PlusBlue ,
  DocsBlack24 ,
  IntegrationAvatar ,
  IconLogoBlack ,
  IconFormError ,
  IconDocs ,
  NumberTwoCheck ,
  MenuMobileActive ,
  ForwardBlue ,
  Invoice ,
  DocFlow ,
  HalykCircled ,
  TicketsCircled ,
  Cart ,
  Salary ,
  InDriverGray ,
  ESF ,
  IconClock ,
  IconCheck24 ,
  NumberThreeCheck ,
  MenuMobileWhite ,
  ForwardLightBlue ,
  Card24 ,
  Tis ,
  IconDownload ,
  IconRefresh ,
  QuestionGreen ,
  API ,
  NumberFourCheck ,
  MenuMobile ,
  VisaLight ,
  Kassa ,
  ProductAccount ,
  PersonalSupport ,
  LargeBusiness ,
  NumberFiveCheck ,
  Chat ,
  Restaurant ,
  UserBlack ,
  Retail ,
  NumberSixCheck ,
  World ,
  Wholesale ,
  Pricing ,
  OnlineStore ,
  ContractCircled ,
  DocsCircled ,
}
/* react/jsx-runtime Not a pure module */
